import {
  GETTHEMELIST_SUCCESS,
  GETTHEMELIST_FAILED,
  RESET_GETTHEMELIST,
  LOADING_GETTHEMELIST,
  NETWORK_ERROR_GETTHEMELIST,
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetGetThemeList = () => {
  return { type: RESET_GETTHEMELIST };
};

const getThemeList = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_GETTHEMELIST });
  await adminServices
    .post("getThemeList", userData, { headers: { AuthToken: authTokenIs } })
    .then((res) => {
      switch (res.data.status) {
        case "success":
          dispatch(getThemeListSuccess(res.data));
          break;
        default:
          dispatch(getThemeListFailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({ type: NETWORK_ERROR_GETTHEMELIST, payload: err });
    });
};
function getThemeListSuccess(data) {
  return {
    type: GETTHEMELIST_SUCCESS,
    payload: data,
  };
}
function getThemeListFailed(data) {
  return {
    type: GETTHEMELIST_FAILED,
    payload: data,
  };
}

export { resetGetThemeList, getThemeList };
